import clsx from 'clsx';

import { sortTaskUsersByName } from '@atom/selectors/taskSelectors';
import { UserDetail } from '@atom/types/user';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import TeamRow from './TeamRow';

import classes from './hidotOvertimeReport.module.css';

type TeamTableProps = {
  users: UserDetail[];
  hours: number;
  date: string;
};

const TeamTable = ({ users, hours, date }: TeamTableProps) => {
  if (isNilOrEmpty(users)) {
    return <div className={classes.emptySection}>No team member added.</div>;
  }

  const sortedUsers = sortTaskUsersByName(users) as UserDetail[];

  return (
    <>
      <div className={classes.teamHeader}>
        <div className={clsx(classes.teamCell, classes.name)}>
          Employee Name
        </div>
        <div className={clsx(classes.teamCell, classes.title)}>
          Position Title
        </div>
        <div className={clsx(classes.teamCell, classes.hours)}>Hours</div>
        <div className={clsx(classes.teamCell, classes.date)}>Date</div>
      </div>
      {sortedUsers.map(user => (
        <TeamRow key={user?.id} user={user} hours={hours} date={date} />
      ))}
    </>
  );
};

export default TeamTable;
